import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import AnswerVariant from './AnswerVariant'
import Button from 'components/UI/Button'
import QuestionaryTimer from './QuestionaryTimer'
import ErrorMessageWithExclamation from '../../../../../UI/ErrorMessageWithExclamation'

import { selectCurrentTest } from '../../../../../../routing/fetchingfunction/user/user.reducer'

const Questionary = ({
  activeQuestionNumber,
  setActiveQuestionNumber,
  answeredQuestions,
  setAnsweredQuestions,
  selectedAnswer,
  setSelectedAnswer,
  questions = [],
  onCancelTest,
  activeCategory,
}) => {
  const currentTest = useSelector(selectCurrentTest)

  const [isEmpty, setIsEmpty] = useState(false)

  // TODO should come from redux
  const activeQuestion = questions[activeQuestionNumber]

  const completePercentage = (answeredQuestions.length / questions.length) * 100

  const handleAnswerClick = (answer) => {
    const existingQuestionIndex = answeredQuestions.findIndex(
      (question) => question.question_id === activeQuestion.id
    )
    if (existingQuestionIndex !== -1) {
      // If the question already exists, update the selected option
      const updatedAnsweredQuestions = [...answeredQuestions]
      updatedAnsweredQuestions[existingQuestionIndex].selected_option = answer
      setAnsweredQuestions(updatedAnsweredQuestions)
    }
    setSelectedAnswer(answer)
  }

  useEffect(() => {
    const existingQuestionIndex = answeredQuestions.findIndex(
      (question) => question.question_id === activeQuestion.id
    )

    if (existingQuestionIndex !== -1) {
      setSelectedAnswer(answeredQuestions[existingQuestionIndex].selected_option)
    }
  }, [answeredQuestions, activeQuestionNumber])

  const handleSubmitAnswer = () => {
    if (answeredQuestions.length >= questions.length) {
      return
    }

    if (!selectedAnswer) {
      return setIsEmpty(true)
    }

    setIsEmpty(false)

    setAnsweredQuestions((prevAnsweredQuestions) => {
      const existingAnswer = prevAnsweredQuestions.find(
        (question) => question.question_id === activeQuestion.id
      )
      const newAnsweredQuestions = existingAnswer
        ? prevAnsweredQuestions.map((answeredQuestion) => {
            if (answeredQuestion.question_id === activeQuestion.id) {
              return { ...answeredQuestion, selected_option: selectedAnswer }
            }
            return answeredQuestion
          })
        : [
            ...prevAnsweredQuestions,
            {
              question_id: activeQuestion.id,
              selected_option: selectedAnswer,
              position: activeQuestionNumber,
            },
          ]
      return newAnsweredQuestions
    })

    setSelectedAnswer(null)

    if (activeQuestionNumber >= questions.length - 1) {
      return
    }
    setActiveQuestionNumber((prevActiveQuestionNumber) => prevActiveQuestionNumber + 1)
  }

  const activeQuestionAnswersContent =
    activeQuestion &&
    activeQuestion.options.map((answer, index) => {
      return (
        answer && (
          <AnswerVariant
            activeQuestionNumber={activeQuestionNumber}
            key={index}
            value={answer}
            index={index}
            isActive={
              index + 1 === selectedAnswer ||
              answeredQuestions.findIndex(
                (question) =>
                  question.selected_option === index + 1 &&
                  activeQuestion.id === question.question_id
              ) !== -1
            }
            onSelect={handleAnswerClick}
          />
        )
      )
    })

  return (
    <div className="mt-6 bg-test-bg !p-4 !pb-[34px]">
      <div className="bg-primary-50 rounded-[10px]">
        <div className="py-8 px-6 flex items-center justify-between">
          <span className="border flex gap-2 font-semibold bg-white py-1 px-3 items-center rounded-lg border-gray-600 text-sm text-[#F79009]">
            <img src={activeCategory?.icon} alt={activeCategory?.name} className="h-7 w-7" />{' '}
            {activeCategory?.title}
          </span>
          <span className="text-primary-75 text-xs">
            QUESTION <span className="font-bold">{activeQuestionNumber + 1}</span> OF{' '}
            {questions.length} | QUESTION ANSWERED{' '}
            <span className="font-bold">
              {answeredQuestions.length}/{questions.length}
            </span>
          </span>

          {currentTest.total_test_time && <QuestionaryTimer onCancelTest={onCancelTest} />}
        </div>

        <div
          role="progressbar"
          aria-valuenow={completePercentage}
          aria-valuemin={0}
          aria-valuemax={100}
          className="relative bg-[#FAD5B9] w-full h-1 flex items-center"
        >
          <div
            style={{ width: `${completePercentage}%` }}
            className="absolute h-full bg-[#F79009] transition-all duration-200 ease"
          />
        </div>

        <div className="pt-6 px-16 pb-[90px] flex flex-col items-start justify-start">
          <h3 className="text-primary-100 text-[22px] font-semibold w-full">
            {activeQuestion?.question_text}
          </h3>

          {isEmpty && (
            <ErrorMessageWithExclamation text="Please select an answer." className="!mt-4" />
          )}

          <div className="mt-4 mb-[10px] w-full">{activeQuestionAnswersContent}</div>

          <div className="flex items-center justify-start w-full">
            {answeredQuestions.length === questions.length && (
              <p className="text-primary-75 font-medium">
                You got all answers, please click "Finish Test" button.
              </p>
            )}

            <Button
              className="ml-auto"
              disabled={answeredQuestions.length === questions.length}
              onClick={handleSubmitAnswer}
            >
              Submit & Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Questionary
